import { render, staticRenderFns } from "./Ivrs.vue?vue&type=template&id=831b45fa&"
import script from "./Ivrs.vue?vue&type=script&lang=js&"
export * from "./Ivrs.vue?vue&type=script&lang=js&"
import style0 from "./Ivrs.vue?vue&type=style&index=0&id=831b45fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports